import { observable, computed } from 'mobx';

class ScrollTipStore {
  constructor(options = {}) {
    Object.assign(this, options);
  }
  @observable mainStore;
  @observable playingKvVideo = false;

  @computed
  get isShowBackTop() {
    return this.mainStore.pageSwiperStore.baseSwiperStore.activeIndex >= this.mainStore.pageSwiperStore.baseSwiperStore.size - 1;
  }

  backTop = () => {
    this.mainStore.pageSwiperStore.baseSwiperStore.onChange(0);
  };

  showCopyRight = () => {
    this.showFooter?.();
  };

  /**
   * 当前页数
   * @type {number}
   */
  @observable currentPageNumber = 1;
  /**
   * 页面总数
   * @type {number}
   */
  @observable currentPageSize = 5;

  /**
   * 是否显示版权提示
   * @type {boolean}
   */
  @observable showScrollTipCopyRight = false;

  /**
   * 是否显示播放背景视频按钮
   * @type {boolean}
   */
  @observable showPlayVideoBgBtn = false;

  controlKvVideo = () => {
    this.playingKvVideo = !this.playingKvVideo;
    if (this.playingKvVideo) {
      this.playKvVideo?.();
    } else {
      this.pauseKvVideo?.();
    }
  };

  // @observable
  use() {}
}

export default ScrollTipStore;
